import { FC, useEffect, ReactNode } from 'react';
import { trackPromoImpressions, trackPromoClick } from '../helpers/sbSharedFeaturedTracking';

// components
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { SbSharedL1FeaturedTile } from '../SbSharedL1FeaturedTile/SbSharedL1FeaturedTile';

// constants
import { DEFAULT_IMAGE_URL } from './sbSharedAuctionBannerConfig';

// styles
import styles from './SbSharedAuctionBanner.scss';

// Creative label from AUCTIONS-793
const CREATIVE_LABEL = 'L1 auction banner';

const SbSharedAuctionBanner: FC<{ vertical: string; position?: number }> = ({
    vertical,
    position,
}) => {
    useEffect(() => {
        trackPromoImpressions([CREATIVE_LABEL], position);
    }, [position]);

    return (
        <SbSharedL1FeaturedTile
            mainImage={DEFAULT_IMAGE_URL}
            heading={
                <FormattedMessage
                    id="abf.SbSharedAuctionBanner.heading"
                    defaultMessage="Browse Auctions"
                />
            }
            subHeading={
                <FormattedMessage
                    id="abf.SbSharedAuctionBanner.subText"
                    defaultMessage="The thrill of the <span>(treasure)</span> hunt"
                    values={{
                        span: (content: ReactNode[]) => (
                            <span className={styles.subTextItalic}>{content}</span>
                        ),
                    }}
                />
            }
        >
            {({ className, children }) => (
                <Link
                    className={className}
                    href={`/auctions/${vertical}/`}
                    onClick={() => trackPromoClick(CREATIVE_LABEL, position)}
                >
                    {children}
                </Link>
            )}
        </SbSharedL1FeaturedTile>
    );
};

export default SbSharedAuctionBanner;
